module.exports = __webpack_public_path__ + "static/media/wrong.4e9517c0.m4a";